import React from 'react';
import PropTypes from 'prop-types';

import SecondaryNav from './footer/secondary_nav';

import Facebook from './socials/facebook.png';
import Twitter from './socials/twitter.png';
import YouTube from './socials/youtube.png';
import Instagram from './socials/instagram.png';
import Flickr from './socials/flickr.png';
import Pinterest from './socials/pinterest.png';
import Soundcloud from './socials/soundcloud.png';

import './style.scss';

const Footer = ({ footer }) => {
    return (
        <footer className="flush-row">
            <div className="flex-container flex-center mt3 mb3">
                <div className="flex-item">
                    <div className="social-nav">
                        <a
                            href="https://www.facebook.com/idaholottery"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img alt="Facebook" src={Facebook} />
                        </a>

                        <a
                            href="https://twitter.com/idaholottery"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img alt="Twitter" src={Twitter} />
                        </a>

                        <a
                            href="https://www.youtube.com/user/idaholottery"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img alt="YouTube" src={YouTube} />
                        </a>

                        <a
                            href="https://www.instagram.com/idaholottery"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img alt="Instagram" src={Instagram} />
                        </a>

                        <a
                            href="https://www.pinterest.com/idaholottery.com"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img alt="Pinterest" src={Pinterest} />
                        </a>

                        <a
                            href="https://www.flickr.com/photos/idaholottery/with/42153046571"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img alt="Flickr" src={Flickr} />
                        </a>

                        <a
                            href="https://soundcloud.com/idaholottery"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img alt="SoundCloud" src={Soundcloud} />
                        </a>
                    </div>
                </div>
                <div className="flex-item">
                    <div className="secondary-nav">
                        <SecondaryNav footer={footer} />
                    </div>
                </div>
            </div>

            <div className="row text-center mx-auto">
                <p>
                    The Idaho Lottery’s mission is to benefit Idaho public
                    schools and buildings.
                    <br />
                    Play Wise. Must be 18+
                </p>
            </div>
        </footer>
    );
};

Footer.propTypes = {
    footer: PropTypes.array.isRequired,
};

export default Footer;
